export const STORE_LOCATOR_LIST = "STORE_LOCATOR_LIST";
export const CHANGE_SELECTED_COUNTRY = "CHANGE_SELECTED_COUNTRY";
export const CHANGE_SELECTED_SHOP = "CHANGE_SELECTED_SHOP";
